
<div
  class="container d-flex justify-content-between align-items-start order-header-row">
  <!-- Left side: Breadcrumb / Heading -->
  <app-linker-route
    [headingName]="headingName"
    [linkerRouteItems]="linkerRouteItems">
  </app-linker-route>

  <!-- Right side: Search + Return button -->
  <div class="d-flex flex-column align-items-end">
    <!-- Search box -->
    <div class="form-group order-search-group">
      <input
        type="text"
        class="form-control order-search-input"
        placeholder="Search your orders..." 
        (input)="onSearchInput($event)"
      />
      <span
        class="fa fa-search"
        class="fa fa-search order-search-icon"
      ></span>
    </div>

    <!-- Return Items Button -->
   <!-- Return Items Button (only if delivered orders exist) -->
<button 
  class="return-product-btn"
  *ngIf="hasDeliveredOrders()" 
  (click)="toggleReturnMode()">
  {{ showCheckboxes ? 'Cancel' : 'Return Product' }}
</button>
  </div>
</div>

<div class="container mb-4 topfooter">
  <div class="row mt-3">
    <div class="order-cards-wrapper">
      <!-- Order Cards -->
      <div *ngFor="let item of orderList; let i=index;" class="order-card">
        <!-- Card Header -->
        <div class="order-card__header">
          <div class="order-card__title">
            <span class="order-card__eyebrow">Order #{{ item?.orderId }}</span>
          </div>
          <div class="order-card__actions">
            <input 
              *ngIf="showCheckboxes"
              type="checkbox"
         [checked]="item.selected"
         (change)="toggleItemSelection(item)"
              [disabled]="item.deliveryStatus !== 'DELIVERED' || (item.returnRequests && item.returnRequests.length > 0)"
              class="order-checkbox">
          </div>
        </div>

        <!-- Card Body -->
        <div class="order-card__body">
          <!-- Product Section with Status -->
          <div class="order-product">
            <div class="order-product__image">
              <img [src]="item?.productDetails[0]?.productId?.thumbnail" [alt]="item?.productDetails[0]?.productId?.productName">
            </div>
            <div class="order-product__info">
              <h4 class="order-product__name">{{ item?.productDetails[0]?.productId?.productName }}</h4>
              
              <!-- All Details in Two Lines -->
              <div class="order-details-inline">
                <!-- First Row: Labels -->
                <div class="detail-label-row">
                  <span class="detail-label">Quantity:</span>
                  <span class="detail-label">Amount:</span>
                  <span class="detail-label">Payment:</span>
                  <span class="detail-label">Order:</span>
                  <span class="detail-label">Delivery:</span>
                  <span class="detail-label">Placed:</span>
                </div>
                <!-- Second Row: Values -->
                <div class="detail-value-row">
                  <span class="detail-value">{{ getNoOfquantity(item?.productDetails) }}</span>
                  <span class="detail-value red-color">{{ item?.orderPrice && getPrice(item?.orderPrice | currency:"ZAR":"R") }}</span>
                  <span class="detail-value" [ngClass]="getStatusTextClass(getPaymentStatus(item))">
                    {{ getPaymentStatus(item) }}
                  </span>
                  <span class="detail-value" [ngClass]="getStatusTextClass(item?.orderStatus)">
                    {{ item?.orderStatus }}
                  </span>
                  <span class="detail-value" [ngClass]="getStatusTextClass(item?.deliveryStatus)">
                    {{ item?.deliveryStatus }}
                  </span>
                  <span class="detail-value">{{ item?.createdAt | date: 'yyyy-MM-dd h:mm:ss a' || '--' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Card Footer -->
        <div class="order-card__footer">
          <button 
            class="view-details-btn"
                  [queryParams]="{_id : item?._id, status: item?.orderStatus}"
                  [routerLink]="['/customer-order-history-view']">
            View Details
          </button>
        </div>
      </div>

      <!-- Skeleton Loader / No Data -->
      <app-table-loader [isTable]="'CARD'" [isLoading]="isLoading" [notFoundData]="notFoundData"></app-table-loader>
      

    
      <!-- <div class="submit-selected-container" *ngIf="showCheckboxes && hasDeliveredOrders()">
          <button 
              class="btn btn-danger submit-selected-btn"
              [disabled]="!anySelected()" 
              (click)="openReturnPolicyModal()">
              Submit Return
          </button>
      </div>
       -->
      <!-- Pagination -->
      <!-- <div class="pagination-section" *ngIf="getTotalPages() > 1">
          <div class="pagination-controls">
              <button 
                  class="pagination-btn prev-btn" 
                  [disabled]="currentPage === 1"
                  (click)="goToPage(currentPage - 1)"
                  [class.disabled]="currentPage === 1">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
              </button> -->
              
              <!-- Dynamic page numbers -->
              <!-- <button 
                  *ngFor="let page of getPageNumbers()" 
                  class="pagination-btn page-btn" 
                  [class.active]="page === currentPage"
                  (click)="goToPage(page)">
                  {{ page }}
              </button>
               -->
              <!-- <button 
                  class="pagination-btn next-btn" 
                  [disabled]="currentPage === getTotalPages()"
                  (click)="goToPage(currentPage + 1)"
                  [class.disabled]="currentPage === getTotalPages()">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
              </button>
          </div> -->

      <!-- Submit Return Button - Above Pagination -->
      <div class="d-flex justify-content-end mt-3" *ngIf="showCheckboxes && hasDeliveredOrders()">
        <button 
          class="btn btn-primary btn-submit-return"
          [disabled]="!anySelected()" 
          (click)="openReturnPolicyModal()">
          <i class="fa fa-check-circle me-2"></i>
          Submit Return
        </button>
      </div>
      
      <!-- Pagination Controls -->
      <div class="pagination-section" *ngIf="count > pageSize">
        <div class="pagination-controls">
          <button 
            class="pagination-btn prev-btn" 
            [disabled]="currentPage === 1"
            (click)="goToPage(currentPage - 1)"
            [class.disabled]="currentPage === 1">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          
          <!-- Dynamic page numbers -->
          <button 
            *ngFor="let page of getPageNumbers()" 
            class="pagination-btn page-btn" 
            [class.active]="page === currentPage"
            (click)="goToPage(page)">
            {{ page }}
          </button>
          
          <button 
            class="pagination-btn next-btn" 
            [disabled]="currentPage === getTotalPages()"
            (click)="goToPage(currentPage + 1)"
            [class.disabled]="currentPage === getTotalPages()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Bootstrap Modal for Return Policy -->
<!-- Return Policy Modal -->
<!-- Bootstrap Modal for Return Policy -->
<div class="modal custom-modal-center" id="returnPolicyModal" tabindex="-1" aria-labelledby="returnPolicyModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered compact-modal">
    <div class="modal-content modern-modal-content">

      <!-- Header -->
      <div class="modern-modal-header">
        <div class="d-flex align-items-center">
          <h5 class="modal-title mb-0" id="returnPolicyModalLabel">Product Return Request</h5>
        </div>
        <button type="button" class="modern-close-btn" aria-label="Close" (click)="cancelReturnForm()">
          ×
        </button>
      </div>

      <!-- Body -->
      <div class="modern-modal-body">
        <form #returnForm="ngForm" (ngSubmit)="submitReturnForm()">

          <!-- Selected Products Preview -->
          <div class="selected-products-section" *ngIf="selectedOrder?.length > 0">
            <label class="section-label">
              Selected Product(s)
            </label>
            <div class="products-grid">
              <div *ngFor="let prod of selectedOrder" class="product-card-mini">
                <div class="product-image-wrapper">
                  <img [src]="prod?.productDetails[0]?.productId?.thumbnail"
                       class="product-thumbnail" alt="Product">
                </div>
                <div class="product-name-mini">
                  {{prod?.productDetails[0]?.productId?.productName}}
                </div>
              </div>
            </div>
          </div>

          <!-- Reason -->
          <div class="form-group-modern">
            <label for="reason" class="section-label">
              Reason for Return
              <span class="required-asterisk">*</span>
            </label>
            <select id="reason"
                    class="modern-select"
                    name="reason"
                    [(ngModel)]="returnData.reason"
                    required>
              <option value="" disabled selected>-- Select a reason --</option>
              <option value="wrong_size"> Wrong Size</option>
              <option value="defective"> Defective / Damaged Item</option>
              <option value="not_as_described">Product Not as Described</option>
              <option value="late_delivery">Late Delivery</option>
              <option value="changed_mind">Changed My Mind</option>
              <option value="other"> Other</option>
            </select>
          </div>

          <!-- Details -->
          <div class="form-group-modern">
            <label for="details" class="section-label">
              Additional Details
            </label>
            <textarea id="details" 
                      class="modern-textarea" 
                      rows="4" 
                      name="details" 
                      [(ngModel)]="returnData.details" 
                      placeholder="Please provide any additional information about your return..."></textarea>
          </div>

          <!-- Upload Images -->
          <div class="form-group-modern">
            <label for="uploadImage" class="section-label">
              Upload Image(s)
            </label>
            <div class="upload-wrapper">
              <input type="file" 
                     id="uploadImage" 
                     class="modern-file-input" 
                     (change)="onFileSelect($event)" 
                     multiple 
                     accept="image/*">
              <label for="uploadImage" class="modern-upload-label">
                Choose Files or Drag & Drop
              </label>
            </div>
          </div>

          <!-- Preview Uploaded Images -->
          <div class="uploaded-images-section" *ngIf="uploadedImages?.length > 0">
            <label class="section-label">
              Selected Images ({{uploadedImages.length}})
            </label>
            <div class="images-preview-grid">
              <div *ngFor="let img of uploadedImages; let i = index" class="image-preview-card">
                <img [src]="img" class="preview-image" alt="Upload preview">
                <button type="button"
                        class="remove-image-btn"
                        (click)="removeUploadedImage(i)"
                        title="Remove image">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Agree Policy -->
          <div class="policy-agreement-section">
            <label class="modern-checkbox-wrapper">
              <input type="checkbox" 
                     class="modern-checkbox-input" 
                     id="agree" 
                     name="agree" 
                     [(ngModel)]="returnData.agree" 
                     required>
              <span class="modern-checkbox-custom"></span>
              <span class="checkbox-label">
                I agree with the return policy
                <span class="required-asterisk">*</span>
              </span>
            </label>
          </div>

          <!-- Buttons -->
          <div class="modal-footer-actions">
            <button type="button" 
                    class="modern-btn modern-btn-secondary" 
                    (click)="cancelReturnForm()">
              Cancel
            </button>
            <button type="submit" 
                    class="modern-btn modern-btn-primary" 
                    [disabled]="!returnForm.valid">
              Submit Return Request
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>
